import { Component, OnInit } from "@angular/core";
import { CAPService } from "../../core/services/cap-service";
import { MatDatepicker } from "@angular/material/datepicker";
import { formatDate } from "@angular/common";
import { Router } from "@angular/router";
import { GridOptions } from "ag-grid-community";
import { DatePipe } from "@angular/common";
//import 'ag-grid-enterprise';
// import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { ViewChild } from "@angular/core";
import { PagerService } from "../../core/services/pager.service";
import * as $ from "jquery";

@Component({
  selector: "app-recoveryreports",
  templateUrl: "./recoveryreports.component.html",
  styleUrls: ["./recoveryreports.component.css"],
})
export class RecoveryreportsComponent implements OnInit {
  @ViewChild("InitiatedDate") InitiatedDate: MatDatepicker<Date>;
  @ViewChild("RInitiatedDate") RInitiatedDate: MatDatepicker<Date>;
  // @ViewChild("CountryList") public CountryList: DropDownListComponent;
  public CountryList:any="";
  public DeviceTypeList;
  public FrequencyTypeList;
  public Reports: ReportDetails = new ReportDetails();
  public updatedReports: ReportDetails = new ReportDetails();
  public dlstDeviceType = "";
  public EmailTo;
  public dlstFrequencyType;
  public SelectedCountry;
  public Country;
  public LoginEnterpriseID;
  public RoleReport;
  public DeviceType;
  public UserCountry;
  public Countries;
  public ReportTypes;
  public loaderGif:boolean = false;
  public ReportType;
  public UpdatedType;

  public dlstReportType = "";
  public dlstCountry;
  public Role;
  public minDate: Date;
  private allItems: any[];
  pager: any = {};
  public Gridflag:boolean = false;
  public Type;

  CountryFields: Object = { text: "Country", value: "Country" };
  // DGData = [];
  //public BulkUploaddata;
  //public TempUserKey = '';
  //bulkFile: any;
  //uploadResponse :any[];
  public successfulData: any = [];
  constructor(
    private CAPService: CAPService,
    private router: Router,
    private datePipe: DatePipe,
    private pagerService: PagerService
  ) {
    this.DeviceTypeList = [
      /*{ name: 'Skype', },{ name: 'Cisco', }, */ { name: "Teams" },
    ];
    this.FrequencyTypeList = [
      { name: "Daily" },
      { name: "Weekly" },
      { name: "Monthly" },
      { name: "Quarterly" },
      { name: "Bi-Annually" },
      { name: "Annually" },
    ];
    this.LoginEnterpriseID = CAPService.enterpriseid;
    this.Role = CAPService.ReportRole;
    this.RoleReport = CAPService.Role;
    this.Country = CAPService.country;
    this.DeviceType = this.dlstDeviceType;
    this.UserCountry = this.CAPService.UserCountry;
  }

  ngOnInit(): void {
    this.minDate = new Date();
    this.CAPService.CountryList("N", "ReportsCountry").subscribe((data) => {
      this.Countries = data;
      this.DeviceType = this.dlstDeviceType;
    });
    this.successfulData = {
      SchedulerId: "",
      Report: "",
      ScheduleDate: "",
      ScheduleFrequency: "",
      Country: "",
      EmailTo: "",
      ReportId: "",
    };
    this.Gridflag = false;
    $(document).ready(function () {

      $('#dlstCountry').find('span').removeAttr("role");

    });
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page, 5);

    // get current page of items
    this.successfulData.RecoveryReport = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  showPicker(): void {
    this.InitiatedDate.open();
  }
  RshowPicker(): void {
    this.RInitiatedDate.open();
  }

  formatDateValue(date: Date) {
    const format = "yyyy-MM-dd";
    const locale = "en-US";
    const result = formatDate(date, format, locale);
    return result;
  }

  calculateDiff(fromdate, todate) {
    const date1: any = new Date(fromdate);
    const date2: any = new Date(todate);
    const diffDays: any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
    return diffDays;
  }
  culateFinDiff(fromdate, todate) {
    const date1: any = new Date(fromdate);
    const date2: any = new Date(todate);
    if (date1 <= date2) {
      return true;
    } else {
      return false;
    }
  }
  calFinDiff(fromdate, todate) {
    const date1: any = new Date(fromdate);
    const date2: any = new Date(todate);
    const res = date2 - date1;

    return res;
  }
  Clear() {
    this.Reports.Country = "";
    this.Reports.ScheduledDate = "";
    this.Reports.FrequencyType = "";
    this.Reports.EmailTo = "";
    // this.CountryList.value = null;
    this.CountryList = "";
    this.InitLoad();
  }
  ReportAction() {
    this.CAPService.CountryList("N", "ReportsCountry").subscribe((data) => {
      this.Countries = data;
    });
  }

  DeviceTypeEvent() {
    this.ReportType = "";
    this.Clear();
    this.loaderGif = true;
    this.DeviceType = this.dlstDeviceType;
    this.ReportTypes=[];
    if (
      this.Role == "Call Charge Report Access" &&
      this.DeviceType == "Teams"
    ) {
      this.ReportTypes.push("Call Detail Report");
    }
    if (this.Role == "Gateway Report Access" && this.DeviceType == "Teams") {
      this.ReportTypes.push("Gateway Report");
    }
    if (this.Role == "Group Report" && this.DeviceType == "Teams") {
      this.ReportTypes.push("Project/Group Report");
    }
    /*2023 Requirement -- removal of Common Area Phone Report
    if (this.Role == 'CAPM Report Access' && (this.DeviceType == 'Teams' || this.DeviceType == 'Teams')) {
      this.ReportTypes.Value.push("Common Area Phone Report");
    }*/
    if (
      this.Role == "Trunk Group Report Access" &&
      this.DeviceType == "Teams"
    ) {
      this.ReportTypes.push("Dial In Conference Call Report");
    }
    if (this.UserCountry == "India") {
      if (
        (this.RoleReport == "Global Admin" ||
          this.RoleReport == "Regional Voice Admin") &&
        this.CAPService.DeviceType == "Cisco"
      ) {
        this.CAPService.GetVoiceAdminDetails(
          this.DeviceType,
          "ReportType",
          this.Country
        ).subscribe((data) => {
          this.ReportTypes = data;
          this.loaderGif = false;
        });
      } else if (
        this.RoleReport == "Global Admin" ||
        this.RoleReport == "Regional Voice Admin"
      ) {
        this.CAPService.DropdownValues("ReportType", this.DeviceType).subscribe(
          (data) => {
            this.ReportTypes = data;
            this.loaderGif = false;
          }
        );
      }
    } else {
      if (
        this.RoleReport == "Global Admin" ||
        this.RoleReport == "Regional Voice Admin"
      ) {
        this.CAPService.DropdownValues("ReportType", this.DeviceType).subscribe(
          (data) => {
            this.ReportTypes = data;
            this.loaderGif = false;
          }
        );
      }
    }
    if (this.RoleReport == "Finance Report") {
      if (
        this.RoleReport == "Finance Report" &&
        this.UserCountry == "India" &&
        (this.DeviceType == "Cisco" || this.DeviceType == "All")
      ) {
        this.CAPService.DropdownValues(
          "FinanceUser",
          this.DeviceType
        ).subscribe((data) => {
          this.ReportTypes = data;
          this.loaderGif = false;
        });
      } else {
        this.CAPService.DropdownValues(
          "FinanceUser",
          this.DeviceType
        ).subscribe((data) => {
          this.ReportTypes = data;
          this.ReportTypes.length = 0;
          this.loaderGif = false;
        });
      }
    }

    this.CAPService.GetVoiceAdminDetails(
      "GetRecoverySchedulerReport",
      "RecoverySchedulerReport",
      null
    ).subscribe((data) => {
      if (data.length > 0) {
        this.loaderGif = true;
        this.successfulData = { RecoveryReport: data, selected: {} };
        this.allItems = data;
        // initialize to page 1
        this.setPage(1);

        this.Gridflag = true;
        this.loaderGif = false;
      }
    });

    this.loaderGif = false;
    // this.Reset();
  }
  GreyCallee() {}
  GetFacility() {}
  FrequencyTypeEvent() {}
  EditReport(RReport) {
    this.successfulData.selected = Object.assign({}, RReport);
  }
  DeleteReport(Report) {
    this.CAPService.DeleteVoiceAdminDetails(
      Report.SchedulerId,
      "SchedulerReport",
      this.LoginEnterpriseID,
      null
    ).subscribe((data) => {
      if (data.length > 0) {
        alert("Deleted Successfully");
        this.Clear();
      } else {
        alert(data);
        this.Clear();
      }
    });
  }
  reset() {
    this.successfulData.selected = {};
  }
  ReportUpdate(RReport) {
    this.loaderGif = true;
    let message = "";

    if ($("#grdReportType").val() == "") {
      message = message + "\n" + "Please Select ReportType";
    }
    if ($("#RInitiatedDate").val() == "") {
      message = message + "\n" + "Please Select Schedule Date";
    }
    if ($("#grdScheduleFrequency").val() == "") {
      message = message + "\n" + "Please Select Schedule Frequency";
    }
    if ($("#grdCountry").val() == "") {
      message = message + "\n" + "Please Select Country";
    }
    if ($("#grdEmailTo").val() == "") {
      message = message + "\n" + "Please Enter Email To";
    }
    if (message != "") {
      alert(message);
    } else {
      switch (RReport.Report) {
        case "Call Charge":
          if (this.dlstDeviceType == "Teams") {
            this.UpdatedType = "CallChargeTeams";
          } else {
            this.Type = "CallCharge";
          }
          break;

        case "Gateway Report":
          if (this.dlstDeviceType == "Teams") {
            this.UpdatedType = "GatewayReportTeams";
          } else {
            this.UpdatedType = "GatewayReport";
          }
          break;
        case "Recovery Reports":
          if (this.dlstDeviceType == "Teams") {
            this.UpdatedType = "RecoveryReportsTeams";
          } else {
            this.UpdatedType = "RecoveryReports";
          }
          break;
        case "Common Area Phone Report":
          {
            /*if (this.dlstDeviceType == 'Teams') {
                this.Type = 'CommonAreaPhoneReportTeams';
            } else {*/
            this.UpdatedType = "CommonAreaPhoneReport";
          }
          break;
        case "Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.UpdatedType = "GroupReportTeams";
          } else {
            this.UpdatedType = "GroupReport";
          }
          break;
        case "Utilization Reports":
          this.UpdatedType = "UtilizationReport";
          break;
        case "Dial In Calls Reports":
          this.UpdatedType = "DialInCallsReports";
          break;
        case "Common Area Phone Reports":
          this.UpdatedType = "CiscoCommonAreaPhoneReport";
          break;
        case "Authcode Mapping Report":
          this.UpdatedType = "AuthcodeMappingReport";
          break;
        case "Conference Call Report":
          this.UpdatedType = "ConferenceCallReport";
          break;
        case "Call Detail Report":
          if (this.dlstDeviceType == "Teams") {
            this.UpdatedType = "CallChargeTeams";
          }
          break;
        case "Finance Report":
          this.UpdatedType = "FinanceReport";
          break;
        case "Authcode Activation/Deactivation Report":
          this.UpdatedType = "Active/DeActiveAuthcode";
          break;

        case "Project/Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.UpdatedType = "GroupReportTeams";
          }
          break;
        case "Dial In Conference Call Report":
          if (this.dlstDeviceType == "Teams") {
            this.UpdatedType = "DialInConferenceCallTeams";
          }
          break;
        case "Ghost Authcode Calls Report":
          this.UpdatedType = "GhostAuthcodeCallsReport";
          break;
        case "Country Report":
          if (this.dlstDeviceType == "Teams") {
            this.UpdatedType = "CallChargeTeams";
          }

          break;
        case "Location Report":
          if (this.dlstDeviceType == "Teams") {
            this.UpdatedType = "LocationReportTeams";
          }
          break;
      }
      this.updatedReports.EnterpriseID = this.LoginEnterpriseID;
      this.updatedReports.SchedulerId =
        this.successfulData.selected.SchedulerId;
      this.updatedReports.Report = this.successfulData.selected.Report;
      this.updatedReports.ScheduledDate =
        this.successfulData.selected.ScheduleDate;
      this.updatedReports.FrequencyType =
        this.successfulData.selected.ScheduleFrequency;
      this.updatedReports.Country = this.successfulData.selected.Country;
      this.updatedReports.EmailTo = this.successfulData.selected.EmailTo;
      this.updatedReports.ReportId = this.successfulData.selected.ReportId;
      this.updatedReports.DeviceType = this.dlstDeviceType;
      this.updatedReports.ReportName = this.UpdatedType;
      this.updatedReports.strType = "RecoverySchedulerReport";
      this.updatedReports.ReportType = "RecoveryReport";
      //this.updatedReports.Report = this.ReportType;
      this.CAPService.UpdateVoiceAdminDetails(this.updatedReports).subscribe(
        (data) => {
          if (data.toString() == "Success") {
            alert("Updated Successfully");
            this.Clear();
            this.loaderGif = false;
          } else if (
            data.toString() ==
            "Please Enter valid User EnterpriseID and ApplicationID"
          ) {
            alert(
              "Please enter valid enterprise Id or\nPlease enter valid application Id"
            );

            this.loaderGif = false;
          } else {
            alert(data);
            this.Clear();
            this.loaderGif = false;
          }
        }
      );
    }
  }

  InitLoad() {
    this.CAPService.GetVoiceAdminDetails(
      "GetRecoverySchedulerReport",
      "RecoverySchedulerReport",
      null
    ).subscribe((data) => {
      if (data.length > 0) {
        this.loaderGif = true;
        this.successfulData = { RecoveryReport: data, selected: {} };
        this.allItems = data;
        // initialize to page 1
        this.setPage(1);
        this.Gridflag = true;
        this.loaderGif = false;
      }
    });
  }

  Send() {
    // this.dataLoader = true;
    // return false;
    debugger;
    this.loaderGif= true;
    //alert(this.dataLoader);
    let message = "";
    if (this.dlstDeviceType == "") {
      message = "Please Select Device Type";
    }
    if (this.dlstReportType == "") {
      message = message + "\n" + "Please Select Report Type";
    }
    if (
      this.Reports.ScheduledDate == "" ||
      this.Reports.ScheduledDate == undefined
    ) {
      message = message + "\n" + "Please Select Schedule Date";
    }

    if (
      this.Reports.FrequencyType == "" ||
      this.Reports.FrequencyType == undefined
    ) {
      message = message + "\n" + "Please Select Frequency Type";
    }
    if (this.CountryList == "") {
      message = message + "\n" + "Please Select Country";
    }
    // if (this.CountryList.value == null) {
    //   message = message + "\n" + "Please Select Country";
    // }
    if (this.Reports.EmailTo == "" || this.Reports.EmailTo == undefined) {
      message = message + "\n" + "Please Enter Email To value";
    }
    if (message != "") {
      alert(message);
      this.loaderGif= false;
    } else {
      this.ReportType = this.dlstReportType;
      switch (this.ReportType) {
        case "Call Charge":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CallChargeTeams";
          } else {
            this.Type = "CallCharge";
          }
          break;
        case "Trunk Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "TrunkGroupReportTeams";
          } else {
            this.Type = "TrunkGroupReport";
          }
        case "Gateway Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GatewayReportTeams";
          } else {
            this.Type = "GatewayReport";
          }
          break;
        case "Recovery Reports":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "RecoveryReportsTeams";
          } else {
            this.Type = "RecoveryReports";
          }
          break;
        case "Common Area Phone Report":
          {
            /*if (this.dlstDeviceType == 'Teams') {
                this.Type = 'CommonAreaPhoneReportTeams';
            } else {*/
            this.Type = "CommonAreaPhoneReport";
          }
          break;
        case "Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GroupReportTeams";
          } else {
            this.Type = "GroupReport";
          }
          break;
        case "Utilization Reports":
          this.Type = "UtilizationReport";
          break;
        case "Dial In Calls Reports":
          this.Type = "DialInCallsReports";
          break;
        case "Common Area Phone Reports":
          this.Type = "CiscoCommonAreaPhoneReport";
          break;
        case "Authcode Mapping Report":
          this.Type = "AuthcodeMappingReport";
          break;
        case "Conference Call Report":
          this.Type = "ConferenceCallReport";
          break;
        case "Call Detail Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CallChargeTeams";
          }
          break;
        case "Finance Report":
          this.Type = "FinanceReport";
          break;
        case "Authcode Activation/Deactivation Report":
          this.Type = "Active/DeActiveAuthcode";
          break;
        // case 'Call Detail Report':
        //     if (this.dlstDeviceType == 'Teams') {
        //         this.Type = 'CallChargeTeams';
        //     }
        //     break;
        case "Project/Group Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "GroupReportTeams";
          }
          break;
        case "Dial In Conference Call Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "DialInConferenceCallTeams";
          }
          break;
        case "Ghost Authcode Calls Report":
          this.Type = "GhostAuthcodeCallsReport";
          break;
        case "Country Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "CallChargeTeams";
          }

          break;
        case "Location Report":
          if (this.dlstDeviceType == "Teams") {
            this.Type = "LocationReportTeams";
          }
          break;
      }
      //Api call
      // this.Reports.Country = this.CountryList.value;
      this.Reports.Country = this.CountryList;
      this.Reports.DeviceType = this.dlstDeviceType;
      this.Reports.ReportName = this.Type;
      this.Reports.strType = "SchedulerReport";
      this.Reports.EnterpriseID = this.LoginEnterpriseID;
      this.Reports.ReportType = "RecoveryReport";
      this.Reports.Report = this.ReportType;

      this.CAPService.InsertVoiceAdminDetails(this.Reports).subscribe(
        (data) => {
          //  this.dataLoader = true;
          if (data.toString() == "Please Enter valid User EnterpriseID") {
            alert("Please enter valid enterprise Id");
            this.loaderGif = false;
          } else if (
            data.toString() ==
            "Please Enter valid User EnterpriseID and ApplicationID"
          ) {
            alert(
              "Please enter valid enterprise Id or\nPlease enter valid application Id"
            );
            this.loaderGif = false;
            // alert(this.dataLoader);
          } else if (data.toString() == "Inserted Successfully") {
            alert("Inserted Successfully");
            this.Clear();
            this.reset();
            this.loaderGif = false;
          } else {
            alert(data);
            this.Clear();
            this.reset();
            this.loaderGif = false;
          }
        }
      );
    }
  //this.loaderGif = true;
  }
}
export class ReportDetails {
  public Country;
  public ScheduledDate;
  public FrequencyType;
  public EmailTo;
  public DeviceType;
  public EnterpriseID;
  public strType;
  public Report;
  public ReportName;
  public ReportType;
  public SchedulerId;
  public ReportId;
}
